import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=071a1834&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a1834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071a1834')) {
      api.createRecord('071a1834', component.options)
    } else {
      api.reload('071a1834', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=071a1834&scoped=true&", function () {
      api.rerender('071a1834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Logo.vue"
export default component.exports